import React, { useEffect, useState } from 'react';
import './splash-screen.scss';

interface SplashScreenProps {
  onComplete: () => void;
  gender?: 'male' | 'female' | null;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        setIsVisible(false);
        onComplete();
      }, 600);
    }, 3500);

    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div className={`splash-screen ${fadeOut ? 'fade-out' : ''}`}>
      <div className="splash-content">
        {/* Stars / decorative circles */}
        <div className="splash-ring splash-ring-outer" />
        <div className="splash-ring splash-ring-inner" />

        {/* Emblem */}
        <img
          src="/logo.png"
          alt="Dubai Police Emblem"
          className="splash-emblem"
        />

        {/* Text */}
        <div className="splash-text">
          <h1 className="splash-title-en">Dubai Police</h1>
          <h1 className="splash-title-ar">شرطة دبي</h1>
          <div className="splash-divider" />
          <p className="splash-subtitle-en">999 Emergency Assistant</p>
          <p className="splash-subtitle-ar">مساعد الطوارئ ٩٩٩</p>
        </div>

        {/* Loading dots */}
        <div className="splash-dots">
          <span /><span /><span />
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
